import * as React from "react";
import './Buy.scss';
import {Link} from "react-router-dom";
import Axios from "../Components/Axios";

import { default as l } from "../../Langs/Langs";
import {IMaskInput} from "react-imask";
import {Alert} from "react-bootstrap";

const backendUrl = process.env.REACT_APP_BACKEND ?? '';
const smsCodeLifeTime = +process.env.REACT_APP_SMS_CODE_LIFETIME;

class Buy extends React.Component{

    getInfo() {

        Axios
            .get(`api/service/${this.state.service}/info`)
            .then(r => {
                if (r?.success && !!r.data.status) {
                    this.setState({ data: r.data ?? {} });
                } else {
                    window.location.href = 'https://megacom.kg';
                }
            })
            .catch(() => this.props.history.push('/'));

    }

    getTimeout() {

        Axios
            .get(`api/service/timeout`)
            .then(r => {
                let timeout = r.data;
                if(!timeout) return;

                this.setState({
                    waitSms: true,
                    timeReaming: smsCodeLifeTime - timeout
                });

                this.timeReamingChange(this);
            });

    }

    constructor(props) {
        super(props);

        this.state = {
            error: false,
            service: this.props.match.params.service,
            agreeded: false,
            waitSms: false,
            code: '',
            invalidCode: false,
            smsError: false,
            lang: this.props.match.params?.lang === 'kg' ? 'kg' : 'ru',
            source: this.props.match.params.source ?? 'no',
            urlCode: this.props.match.params?.urlCode ?? ''
        };

        setTimeout(()=>{
            try {
                document
                    .getElementsByClassName('buy-page')
                    .item(0)
                    .style
                    .opacity = 1;
            }
            catch (E){
            }
        }, 200);

        document.title = 'Подключение услуги';
    }


    handleChange(e, field, parent = null) {

        let isCheckbox = e.target.type === 'checkbox';

        if(parent === null) {
            this.setState({
                [field]: isCheckbox ? e.target.checked : e.target.value
            });
        }
        else
        {
            let parentNode = this.state[parent];
            parentNode[field] = isCheckbox ? e.target.checked : e.target.value;
            this.setState({
                [parent]: parentNode
            });
        }
    }

    formatTime(seconds) {
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = Math.round(seconds % 60);
        return [
            h,
            m > 9 ? m : (h ? '0' + m : m || '0'),
            s > 9 ? s : '0' + s
        ].filter(Boolean).join(':');
    }

    connect() {

        this.setState({
            smsError: false,
            maxCount: false,
            expiredCode: false
        });

        Axios
            .post(
                'api/connect',
                {
                    msisdn: this.state.msisdn.replace(/\D/g, ''),
                    service: this.props.match.params.service,
                    lang: this.state.lang,
                    source: this.state.source,
                    urlCode: this.state.urlCode
                }
            )
            .then(r => {
                if(!r?.success) {
                    this.setState({
                        smsError: true
                    });
                    return;
                }

                if(r.message === 'connected') {
                    window.location.href = r.data;
                }
                else
                {
                    this.setState({
                        waitSms: true,
                        timeReaming: smsCodeLifeTime
                    });
                    this.timeReamingChange(this);
                }

            });
    }

    timeReamingChange(self) {
        self.setState({
            timeReaming: this.state.timeReaming <= 0 ? 0 : --self.state.timeReaming
        });
        if(self.state.timeReaming > 0)
            setTimeout(() => self.timeReamingChange(self), 1000);
        else
            console.log('done time');
    }

    handleSubmit(e) {
        e.preventDefault();
        this.connect();
    }

    handleSubmitSms(e) {
        e.preventDefault();
        Axios
            .post('api/connect/confirm_code', {
                code: this.state.code,
                msisdn: this.state.msisdn.replace(/\D/g, ''),
                service: this.state.service,
                lang: this.state.lang,
                source: this.state.source,
                urlCode: this.state.urlCode
            })
            .then(r => {
                if(!r?.success) {

                    if(r.message === 'Max count') {
                        this.setState({
                            maxCount: true,
                            invalidCode: false,
                            code: '',
                            expiredCode: false
                        });
                        return;
                    }

                    if(r.message === 'Expired code') {
                        this.setState({
                            maxCount: false,
                            invalidCode: false,
                            code: '',
                            expiredCode: true
                        });
                        return;
                    }

                    this.setState({
                        invalidCode: true,
                        code: '',
                        expiredCode: false
                    });
                    return;
                }

                if(r.message === 'connected') {
                    window.location.href = r.data;
                }

            });

    }

    dpiMsIsdn() {
        Axios
            .get('api/connect/dpi_msisdn')
            .then(r => this.setState({ msisdn: r.data}));
    }

    componentDidMount() {
        this.getInfo();
        this.dpiMsIsdn();
        this.getTimeout();
    }

    sendSms(self) {
        self.connect();
    }

    render() {
        const lang = this.state.lang;
        const langUp = lang.charAt(0).toUpperCase() + lang.slice(1);
        return (
            <div className="container pt-3 pb-3 buy-page">
                <div className="card  shadow  border-0" style={{maxWidth: "500px", margin: "auto"}}>
                    {
                        !!this.state.data &&
                        <img
                            className="card-img-top"
                            style={{width: '100%'}}
                            src={`${backendUrl}api/uploads/${(this.state?.data?.['poster' + langUp] ?? '').split('.')[0]}`}
                            alt=""
                        />
                    }
                    <div className="card-body">

                        <h5 className="card-title mb-0">{this.state?.data?.['title' + langUp]}</h5>
                        {
                            !this.state.waitSms &&
                            <>
                                <h6 className="card-title mt-2 text-secondary p-0">{this.state?.data?.['price' + langUp]}</h6>
                                <form onSubmit={e => this.handleSubmit(e, this)}>
                                    {
                                        !!this.state?.smsError &&
                                        <div className="alert alert-danger my-4">{ l[lang].v('Некорректный номер') }</div>
                                    }
                                    <label className="mt=4">{ l[lang].v('Ваш номер телефона') }:</label>
                                    <IMaskInput
                                        mask={'{0}(000)00-00-00'}
                                        type="tel"
                                        className="form-control mb-4 mt-1"
                                        placeholder="0(555)11-22-33"
                                        value={this?.state?.msisdn ?? ''}
                                        onChange={e => this.handleChange(e, 'msisdn')}
                                    />
                                    <ul className="unstyled centered mb-2">
                                        <li>
                                            <input
                                                className="styled-checkbox"
                                                id="styled-checkbox-1"
                                                type="checkbox"
                                                required
                                                checked={this.state.agreeded}
                                                onChange={e => this.handleChange(e, 'agreeded')}
                                            />
                                            <label htmlFor="styled-checkbox-1">{
                                                l[lang].v('Согласен с условиями предоставления сервиса')
                                            }</label>
                                        </li>
                                    </ul>
                                    <button
                                        type="submit"
                                        className="btn btn-block btn-success"
                                        disabled={!this.state.agreeded || !this.state?.msisdn?.length || this.state.msisdn.replace(/\D/g, '').length !== 10}
                                    >
                                        { l[lang].v('Подключить') }
                                    </button>
                                    <Link className="btn btn-block mt-4 btn-primary " to={'/' + this.state.service + '/info/' + this.state.source + '/' + lang}>
                                        { l[lang].v('Подробнее об услуге') }
                                    </Link>
                                </form>
                            </>
                        }
                        {
                            this.state.waitSms &&
                            <>
                                {
                                    //!this.state.maxCount &&
                                    <h6 className="card-title mt-0 text-success p-0">{l[lang].v('Вам выслан SMS-код, введите его')}:</h6>
                                }
                                <form onSubmit={e => this.handleSubmitSms(e)}>
                                    {
                                        this.state.invalidCode &&
                                        <Alert variant={'danger'}>
                                            { l[lang].v('Неправильный SMS-код') }.
                                        </Alert>
                                    }
                                    {
                                        !!this.state.maxCount &&
                                        <Alert variant={'danger'}>
                                            { l[lang].v('Превышено максимальное количество попыток ввода') }.
                                        </Alert>
                                    }
                                    {
                                        !!this.state.expiredCode &&
                                        <Alert variant={'danger'}>
                                            { l[lang].v('Время SMS-кода истекло') }.
                                        </Alert>
                                    }
                                    {
                                        //!this.state.maxCount &&
                                        <input
                                            type="text"
                                            maxLength={4}
                                            value={this.state.code}
                                            className="form-control my-4"
                                            placeholder="XXXX"
                                            onChange={e => this.handleChange(e, 'code')}
                                            disabled={!!this.state.maxCount}
                                        />
                                    }
                                    {
                                        //!this.state.maxCount &&
                                        <button
                                            disabled={!!this.state.maxCount || this.state.code.length !== 4}
                                            type="submit"
                                            className="btn btn-block btn-success"
                                        >
                                            {l[lang].v('Подтвердить')}
                                        </button>
                                    }
                                    {
                                        !!this.state.timeReaming &&
                                        <h6
                                            className="card-title mt-4 text-center text-secondary p-0">
                                            { l[lang].v('SMS timer 1') } <span id="timer">
                                                {this.formatTime(this.state.timeReaming ?? 0)}
                                            </span> { l[lang].v('SMS timer 2') }.
                                        </h6>
                                    }
                                    {
                                        !this.state.timeReaming &&
                                        <button
                                            type="button"
                                            className="btn btn-block mt-4 btn-primary"
                                            onClick={() => this.sendSms(this)}
                                        >
                                            { l[lang].v('Повторить SMS') }
                                        </button>
                                    }
                                </form>
                            </>
                        }
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 text-center mt-4 mb-2 px-2">
                        <a
                            href={'/' + this.state.service + '/' + this.state.source + '/' + ((this.state.lang === 'ru') ? 'kg' : 'ru') + '/' + (this.state.urlCode || '') }
                        >
                            { l[lang].v('На русском') }
                        </a>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 text-center mt-2 mb-4 px-2">
                        <a href={this.state?.data?.['moreUrl' + langUp] ?? ''}>{ l[lang].v('Условия предоставления сервиса') }</a>
                    </div>
                </div>
            </div>
        );
    }
}

export default Buy;